// @ts-strict-ignore
const cyrillicPattern = /[^\u0000-\u007f]/;

export const wrappedAlgoliaClient = (algoliaClient) => {
  return {
    ...algoliaClient,
    search(requests) {
      if (
        requests.every(({ params }) => !params.query) ||
        requests.some(({ params }) => cyrillicPattern.test(params.query))
      ) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0
          }))
        });
      }

      return algoliaClient.search(requests);
    }
  };
};
